import React, { Component } from 'react';
import { translate } from 'react-i18next';
import ArenaOnBoardingPage from '../components/ArenaOnboardingPage/ArenaOnboardingPage';

class ArenaOnBoardingController extends Component {
  componentDidMount() {
    const { referralAdditionalInfo, sendBi } = this.props;
    const previousPage = referralAdditionalInfo && referralAdditionalInfo === 'mylogos' ? 'MyLogos' : 'LandingPage';
    sendBi('logoPageView', { origin: 'no', pageName: 'arenaSplitPage', previousPage });
  }

  render() {
    const { t, goToOnBoarding, goToArena, sendBi } = this.props;

    return (
      <ArenaOnBoardingPage
        t={t}
        onGoToOnArena={() => {
          sendBi('arenaSplitPageArenaClick', {});
          goToArena();
        }}
        onGoToOnBoarding={goToOnBoarding}
      />
    );
  }
}

export default translate()(ArenaOnBoardingController); // instead of "export default App;"
